document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-os-s7-text .z-ani-o', { opacity: 0, y: 40 });
    let cOsS7Tl1 = gsap.timeline({ paused: true });
    cOsS7Tl1.to('.co-os-s7-frame .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-os-s7-frame .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cOsS7Tl1
    });
});